import * as React from "react";
import styled, { css } from "styled-components";
import { OverlayTrigger } from "components/common";
import Icon from "components/common/Icon";
const StyledPopover = styled.span(
  ({ theme }) => css`
    ul {
      padding-left: 0;
    }

    li {
      margin-bottom: 5px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    h4 {
      font-size: ${theme.fonts.size.large};
    }
  `
);
const StyledIcon = styled(Icon)(
  ({ theme, $type, $displayLeftMargin }) => css`
    display: inline-flex;
    color: ${$type === "error" ? theme.colors.variant.danger : "inherit"};
    margin: 0;
    margin-left: ${$displayLeftMargin ? "0.3em" : 0};
    pointer-events: auto !important;
  `
);
const iconName = (type) => {
  switch (type) {
    case "error":
      return "error";
    case "info":
    default:
      return "help";
  }
};
const HoverForHelp = ({
  children,
  className = "",
  displayLeftMargin = false,
  title = void 0,
  id = "help-popover",
  pullRight = true,
  placement = "bottom",
  triggerTitle = void 0,
  testId = void 0,
  type = "info",
  iconSize = void 0,
  trigger = ["hover", "focus"],
  width = void 0
}) => /* @__PURE__ */ React.createElement(
  OverlayTrigger,
  {
    trigger,
    placement,
    overlay: /* @__PURE__ */ React.createElement(StyledPopover, { id }, children),
    triggerTitle,
    title,
    testId,
    width
  },
  /* @__PURE__ */ React.createElement(
    StyledIcon,
    {
      className: `${className} ${pullRight ? "pull-right" : ""}`,
      name: iconName(type),
      type: "regular",
      $type: type,
      $displayLeftMargin: displayLeftMargin,
      size: iconSize
    }
  )
);
export default HoverForHelp;
